import { IconType } from 'react-icons';
import { FaCircleCheck } from 'react-icons/fa6';
import PropTypes from 'prop-types';

export interface ValidationIconProps {
  MainIcon: IconType;
}

const ValidationIcon: React.FC<ValidationIconProps> = ({ MainIcon }) => (
  <div style={{ position: 'relative', display: 'inline-block' }}>
    <MainIcon style={{ position: 'relative', top: '2px', left: '2px' }} />
    <FaCircleCheck size={'70%'} style={{ position: 'absolute', bottom: -6, right: -8 }} color="black" />
  </div>
);

// Using PropTypes.any due to ESLint rule. TODO: Disable react/prop-types rule.
ValidationIcon.propTypes = {
  MainIcon: PropTypes.any.isRequired,
};

export default ValidationIcon;
